class EstudoHandle {

    formToJso(formData) {
        return {
            id: formData.id,
            titulo: formData.titulo,
            subtitulo: formData.subtitulo,
            conteudo: formData.conteudo,
            status: formData.status,
            categoria_id: formData.categoria_id,
        };
    }

}

export default new EstudoHandle();